<template>
    <div id="page-name" data-name="error404">

      <!--404-->
      <section id="error" class="padding">
        <div class="container error_content">
          <div class="row">
            <div class="col-md-12 text-center">
              <img src="images/404.png" alt="error" class="margin_bottom">
              <h2 class="uppercase bottom30">запрашиваемый ресурс не существует</h2>
              <h1 class="uppercase content_space">Страница не найдена!</h1>
              <p>Если Вы увидели это сообщение, значит страницы, к которой Вы пытаетесь обратиться не существует, либо она была удалена. Для перехода на <a href="/">главную страницу перейдите по ссылке</a>. Если Вы уверены, что оказались на этой странице в результате ошибки, то можете направить свои предложения по электронному адресу: <a href="mailto:info@oknaogon.ru">info@oknaogon.ru</a></p>
              <form class="input-group-wrapper margintop40">
               <div class="form-grou clearfixp">
              <div class="col-sm-2"></div>
              <div class="col-sm-8">
              </div>
              <div class="col-sm-2"></div>
              </div>
              </form>
            </div>
          </div>
        </div>
      </section>

    </div>
</template>

<script>
  export default {
    name: "Stocks"
  }
</script>

<style scoped>
  .blog_text h5{
    font-size: 26px;
    color: #0060aa;
    line-height: 140%;
  }
  .blog_text p{
    font-size: 16px;
  }
</style>
